<template>
  <div class="container">
    <iframe id="ifr" :src="ifr" frameborder="0"></iframe>

    <div class="back">
        <img @click.stop="$router.push({path:'/list'})" :src="`${$cdn}images/${isMobile?'mobile/icon_mscene_back@2x':'icon_scene_back@2x'}.png`" alt />
    </div>

  </div>
</template>

<script>
import { newTab } from "@/components/data";
import browser from '@/utils/browser'

export default {
  name: "Home",
  props:['musicStatus'],
  data() {
    let acItem = newTab.find(item=>item.tag === this.$route.params.url)
    return {
      isMobile: browser.mobile,
      ifr: acItem ? acItem.url : newTab[0].url
    };
  },
  methods: {
 
  },
  mounted() {
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  iframe {
    width: 100%;
    height: 100%;
  }

  .introduce{
    position: absolute;
    top: 30px;
    left: 50%;
    transform: translateX(-50%);
    cursor: pointer;
    h1{
      color: #fff;
      letter-spacing: 1px;
      font-size: 18px;
      font-weight: normal;
      line-height: 48px;
      height: 48px;
      min-width: 390px;
      text-align: center;
      position: relative;
      background: linear-gradient(89deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.2) 29%, rgba(0, 0, 0, 0.2) 69%, rgba(0, 0, 0, 0) 100%);
      img{
        position: absolute;
        width: 12px;
        right: 110px;
        top: 50%;
        transform: translateY(-50%);
        left: unset;
      }
    }
    .open{
      text-align: center;
      border: 2px solid rgba(255, 255, 255, 0.3);
      width: 200px;
      line-height: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 20px;
      color: #fff;
      position: relative;
       img{
        position: absolute;
        width: 14px;
        right: 20px;
        top: 50%;
        transform: translateY(-50%);
        left: unset;
      }
      .intro{
        background: rgba(0, 0, 0, 0.5);
        border-radius: 4px;
        width: 280px;
        position: absolute;
        padding: 14px 16px;
        line-height: 1.5;
        text-align: justify;
        font-size: 14px;
        top: 48px;
        cursor: auto;
      }
    }
  }

  .back{
    position: absolute;
    top: 30px;
    left: 30px;
    z-index: 999;
    img{
      width: 48px;
    }
  }
  
  .overlook{
    position: absolute;
    bottom: 40px;
    left: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    img{
      cursor: pointer;
      width: 48px;
    }
    span{
      color: #fff;
      display: inline-block;
      text-align: center;
      font-size: 14px;
      margin-top: 4px;
    }
  }

  .darknight{
    position: absolute;
    bottom: 76px;
    left: 50%;
    transform: translateX(-50%);
    img{
      width: 88px;
      cursor: pointer;
    }
  }

  .map{
    position: absolute;
    top: 100px;
    right: 30px;
    img{
      cursor: pointer;
      width: 100px;
    }
  }

  .aside {
    position: fixed;
    right: 30px;
    top: 50%;
    transform: translateY(-50%);
    li {
      cursor: pointer;
      margin-top: 20px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img {
        width: 64px;
      }
      span{
        text-align: center;
        color: #fff;
        margin-top: 2px;
        font-size: 14px;
      }
    }
  }

  .list{
    position: fixed;
    bottom: 120px;
    width: 100%;
    background: rgba(0, 0, 0, 0.3);
    >ul{
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 10px 0;
      >li{
        font-size: 0;
        width: 142px;
        margin: 0 5px;
        position: relative;
        border: solid 2px rgba(0, 0, 0, 0);
        border-radius: 8px;
        overflow: hidden;
        >img{
          width: 100%;
          cursor: pointer;
        }
        >span{
          position: absolute;
          bottom: 0;
          left: 0;
          background: rgba(0, 0, 0, 0.5);
          width: 100%;
          color: #fff;
          font-size: 14px;
          text-align: center;
        }
      }
      .active{
          border: solid 2px #E6C78E;
          border-radius: 8px;
      }
    }
  }
}

@media screen and (max-width: 500px) {
  .container {
    max-width: 500px;
    .introduce{
      z-index: 999;
      top: 10px;
      h1{
        min-width: 310px;
        line-height: 40px;
        height: 40px;
        img{
          position: absolute;
          width: 12px;
          right: 60px;
          transform: translateY(-50%);
          left: unset;
        }
      }
    }
    .map{
      top: 70px;
      right: 20px;
      img{
        width: 90px;
      }
    }
    .aside {
      top: 180px;
      transform: translateY(0);
      right: 20px;
      li {
        margin-top: 15px;
        img {
          width: 44px;
        }
      }
    }

    .home_btn{
      bottom: 64px;
      img{
        width: 144px;
      }
    }
  .back{
      position: absolute;
      top: 16px;
      left: 32px;
      img{
        width: 30px;
      }
    }
    
  .overlook{
      bottom: 30px;
      left: 20px;
      img{
        width: 44px;
      }
    }
  }
  .container{
    .darknight{
      bottom: 50px;
      right: 20px;
      left: unset;
      transform: translateX(0);
      img{
        width: 88px;
        cursor: pointer;
      }
    }
  }
}
</style>